/* eslint-disable import/prefer-default-export */

/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const tourStyles = (selectedVariant) => ({
  options: {
    zIndex: 10000,
    primaryColor: '#007bff',
    backgroundColor: '#f5f5f5',
    textColor: '#333',
    arrowColor: '#ffffff',
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    width: 300,
    borderRadius: 12,
    fontFamily: 'Lexend',
  },
  tooltipContainer: {
    textAlign: 'left',
    fontFamily: 'Lexend',
    fontSize: '16px',
    padding: '12px',
  },
  buttonNext: {
    backgroundColor: selectedVariant?.palette?.primary?.main,
    color: '#fff',
    borderRadius: '6px',
    padding: '6px 6px',
    fontFamily: 'Lexend',
  },
  buttonBack: {
    color: 'black',
    marginRight: 10,
    fontFamily: 'Lexend',
  },
  buttonSkip: {
    color: '#999',
    fontFamily: 'Lexend',
  },
  spotlight: {
    borderRadius: '12px',
  },
});
